$(window).scroll(function () {
  $(window).scrollTop() >= 100
    ? ($(".navbar-sticky").addClass("navbar-stuck"),
      $(".desktop-toggle").addClass("visible-hamburger"),
      $(".header-fixed").addClass("fixed-header"),
      $(".middle-header").addClass("fixed-header"),
      $(".header-menu ").hide())
    : ($(".navbar-sticky").removeClass("navbar-stuck"),
      $(".desktop-toggle").removeClass("visible-hamburger"),
      $(".header-fixed").removeClass("fixed-header"),
      $(".middle-header").removeClass("fixed-header"),
      $(".header-menu ").show());
}),
  $(document).on("click", ".all-cat-wrapper", function () {
    $(".desktop-header .all-cat-drop").toggle();
  }),
  $(document).on("click", ".all-cat-search", function () {
    $(".all-search-drop").toggle();
  }),
  $(document).on("click", ".mb-all-cat", function () {
    $(".mb-bottom-left-col .offcanvas.offcanvas-start").addClass("show"),
      $(".offcanvas-backdrop").addClass("show");
  }),
  $(document).on("click", ".offcanvas-header .btn-close", function () {
    $(".mb-bottom-left-col .offcanvas.offcanvas-start").removeClass("show"),
      $(".offcanvas-backdrop").removeClass("show");
  }),
  $("#shopify-section-collection-template-boost-pfs-filter").length > 0 &&
    ($(".boost-pfs-filter-left-col-inner").prepend(
      "<div class='flidersearchbox'> </div>"
    ),
    $(".flidersearchbox").prepend($(".boost-pfs-in-collection-search")),
    $(".flidersearchbox").prepend(
      $(
        ".boost-pfs-filter-collection-header-wrapper.boost-pfs-filter-collection-image"
      )
    )),
  $(".boost-pfs-filter-right-col").length > 0 &&
    $(".boost-pfs-filter-left-col").on("DOMSubtreeModified", function () {
      {
        $(".boost-pfs-filter-right-col").prepend(
          '<div class="tag_filter_options">test</div>'
        );
        var s = $(".boost-pfs-filter-option-tag").clone();
        $(".tag_filter_options").html(s),
          $(".boost-pfs-filter-right-col")
            .find(".boost-pfs-filter-option-tag")
            .show(),
          $(".tag_filter_options")
            .find("ul li.boost-pfs-filter-option-item")
            .click(function () {
              var s = $(this).index() + 1;
              $(".tag_filter_options")
                .find("ul li.boost-pfs-filter-option-item")
                .not(this)
                .removeClass("selected"),
                $(this).hasClass("selected")
                  ? $(this).removeClass("selected")
                  : $(this).addClass("selected"),
                $(".boost-pfs-filter-tree-mobile-sticky:visible") &&
                  $(".boost-pfs-filter-tree-mobile-sticky")
                    .find(
                      ".boost-pfs-filter-option-tag ul li:nth-child(" + s + ")"
                    )
                    .click();
            });
      }
    }),
  $(".desktop-toggle").click(function () {
    $(".header-menu").toggleClass("show");
  }),
  $(".header-top-bar button").click(function () {
    $(".header-top-bar").hide();
  }),
  $(".header-top-bar button").click(function () {
    $(".header-menu").addClass("top-5");
  }),
  $(".belt-slider").slick({
    dots: !0,
    infinite: !1,
    speed: 300,
    arrows: !0,
    centerPadding: 40,
    dots: !1,
    slidesToShow: 10,
    slidesToScroll: 8,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 5,
          infinite: !0,
          dots: !1,
          arrows: !0,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          arrows: !0,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: !0,
          dots: !0,
          autoplay: !1,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
    ],
  }),
  $(".belt-slider2").slick({
    dots: !0,
    infinite: !1,
    speed: 300,
    arrows: !0,
    centerPadding: 40,
    dots: !1,
    slidesToShow: 14,
    slidesToScroll: 8,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 5,
          infinite: !0,
          dots: !1,
          arrows: !0,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 2,
          arrows: !0,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 2,
          arrows: !0,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          arrows: !0,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: !0,
          dots: !0,
          autoplay: !1,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
    ],
  }),
  $(".machine-list").slick({
    dots: !0,
    infinite: !1,
    speed: 300,
    arrows: !1,
    centerPadding: 40,
    dots: !1,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 3,
          infinite: !0,
          dots: !1,
          arrows: !1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          arrows: !1,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: !1,
          dots: !0,
          autoplay: !1,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: !1,
          dots: !0,
          autoplay: !1,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
    ],
  }),
  $(".collection-carousel").slick({
    dots: !0,
    infinite: !0,
    speed: 300,
    rows: 2,
    autoplay: !0,
    speed: 2e3,
    autoplay: !1,
    autoplaySpeed: 1e4,
    dots: !1,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: !1,
          dots: !1,
          arrows: !0,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: !0,
          dots: !0,
          autoplay: !0,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: !0,
          dots: !0,
          autoplay: !0,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: !0,
          dots: !0,
          autoplay: !0,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: !0,
          autoplay: !0,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
    ],
  }),
  $(window).on("ready load resize", function () {
    var s = 0,
      o = $(window).width();
    $(".featured-product-content .equal-height").css("min-height", "inherit"),
      o > 600 &&
        ($(".featured-product-content .equal-height").each(function (o, e) {
          $(this).outerHeight() > s && (s = $(this).outerHeight());
        }),
        $(".featured-product-content .equal-height").css("min-height", s));
  });
var QtyInput = (function () {
  var s = $(".qty-input");
  if (s.length) {
    var o = s.find(".product-qty"),
      e = s.find(".qty-count"),
      t = parseInt(o.attr("min")),
      i = parseInt(o.attr("max"));
    o.change(function () {
      var s = $(this),
        o = s.siblings(".qty-count--minus"),
        e = s.siblings(".qty-count--add"),
        l = parseInt(s.val());
      isNaN(l) || l <= t
        ? (s.val(t), o.attr("disabled", !0))
        : (o.attr("disabled", !1),
          l >= i
            ? (s.val(i), e.attr("disabled", !0))
            : (s.val(l), e.attr("disabled", !1)));
    }),
      e.click(function () {
        var s = this.dataset.action,
          o = $(this),
          e = o.siblings(".product-qty"),
          l = parseInt(e.val());
        "add" == s
          ? ((l += 1) >= t + 1 &&
              o.siblings(".qty-count--minus").attr("disabled", !1),
            l >= i && o.attr("disabled", !0))
          : ((l = l <= t ? t : (l -= 1)) == t && o.attr("disabled", !0),
            l < i && o.siblings(".qty-count--add").attr("disabled", !1)),
          e.val(l);
      });
  }
})();
$(document).ready(function () {
  $(".decrease_").click(function () {
    var s, o;
    (s = this),
      (o = parseInt($(s).siblings("input#number").val(), 10)),
      (o = isNaN(o) ? 0 : o) < 1 && (o = 1),
      o--,
      $(s).siblings("input#number").val(o);
  }),
    $(".increase_").click(function () {
      var s, o;
      (s = this),
        (o = parseInt($(s).siblings("input#number").val(), 10)),
        (o = isNaN(o) ? 0 : o),
        o++,
        $(s).siblings("input#number").val(o);
    });
}),
  $(".card-listing").click(function () {
    $(".store-featured ").toggleClass("card-detail");
  }),
  $(".product-featured").slick({
    dots: !0,
    infinite: !1,
    speed: 300,
    arrows: !0,
    centerPadding: 40,
    dots: !1,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 5,
          infinite: !0,
          dots: !1,
          arrows: !1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: !1,
          dots: !1,
          autoplay: !1,
          autoplaySpeed: 2e3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: !1,
          dots: !0,
          autoplay: !1,
          autoplaySpeed: 2e3,
          speed: 1200,
        },
      },
    ],
  })
